import { render, staticRenderFns } from "./message-image.vue?vue&type=template&id=644a5269&scoped=true"
import script from "./message-image.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-image.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-image.vue?vue&type=style&index=0&id=644a5269&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644a5269",
  null
  
)

export default component.exports